<template>
	<div data-tour-scope="returns-list">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.returns') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
								<v-icon left>mdi-school-outline</v-icon>
								Tutorial guidato
							</v-btn>
							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!-- <v-divider vertical></v-divider>-->
								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->
								<!-- una sola azione: il "+" porta direttamente alla pagina del nuovo reso -->
								<v-btn elevation="0" text data-tour="add" title="Aggiungi reso" @click="openNew">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>


						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="3" data-tour="search">
									<v-text-field v-model="searchfield" label="Cerca ordine, cliente, SKU o prodotto" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.platform" :items="platform" outlined multiple dense label="Piattaforma" hide-details></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.payments" :items="payments" outlined multiple dense label="Pagamento" hide-details></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select
										v-model="settings.filters.status"
										:items="[
											{ name: 'Richiesta di reso', value: 'REQUEST_RETURN' },
											{ name: 'Richiesta accettata', value: 'ACCEPTED_RETURN' },
											{ name: 'Reso completato', value: 'CONFIRM_RETURN' },
											{ name: 'Reso non autorizzato', value: 'REQUEST_RETURN_NOT_AUTHORIZED' },
										]"
										outlined
										hide-details
										multiple
										dense
										label="Stato"
										item-text="name"
										item-value="value"
									></v-select>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							data-tour="table"
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							must-sort
							:server-items-length="total"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:mobile-breakpoint="0"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards return-cards': mobileCards }"
							no-data-text="Nessun reso con questi filtri"
						>
							<template v-slot:item="{ item }">
								<!-- telefono: ogni reso e' una card; il "+" apre il dettaglio DENTRO la card -->
								<tr v-if="mobileCards">
									<td :colspan="headers.length" class="px-3 py-1">
										<key-value-card :fields="campiCard(item)">
											<template v-slot:title>
												<span>{{ item.OrderID }}</span>
												<span v-if="nomeCliente(item)" class="font-weight-regular"> - {{ nomeCliente(item) }}</span>
											</template>
											<template v-slot:actions>
												<v-btn small icon color="primary" title="Dettaglio ordine" data-tour="order-link" @click="detailItem(item)">
													<v-icon>mdi-magnify</v-icon>
												</v-btn>
												<v-menu bottom left eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn small icon v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
															<v-icon>mdi-dots-vertical</v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item link data-tour="row-edit" @click="editItem(item)">
															<v-list-item-title class="size9">Modifica</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
												<v-btn small icon color="primary" data-tour="expand" :title="checkpresenza(item._id) ? 'Chiudi' : 'Mostra dettaglio'" @click="extension(item._id)">
													<v-icon>{{ checkpresenza(item._id) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</template>
											<template v-slot:top>
												<div class="d-flex align-center flex-wrap mb-1">
													<v-avatar size="28px" tile>
														<img :src="getImageMarketplace(item.Platform)" :alt="item.Platform" />
													</v-avatar>
													<v-avatar size="16px" tile class="ml-1" v-if="item.Country">
														<img :src="getImageFlag(item)" :alt="item.Country" />
													</v-avatar>
													<v-spacer></v-spacer>
													<v-chip v-if="item.status && coloreStatoReso(item.status.value)" small :color="coloreStatoReso(item.status.value)" text-color="white" data-tour="status">
														{{ item.status.name }}
													</v-chip>
												</div>
											</template>
											<ReturnDetail v-if="checkpresenza(item._id)" :item="item" @edit="editItem(item)" @open-order="detailItem(item)" />
										</key-value-card>
									</td>
								</tr>
								<template v-else>
									<tr class="rt-list-row" :class="{ 'rt-list-row--open': checkpresenza(item._id) }" @click="extension(item._id)">
										<td class="pl-0 pr-0" style="width: 40px" @click.stop>
											<v-menu bottom right eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn small icon v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
														<v-icon>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link data-tour="row-edit" @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td class="pl-0 pr-0" style="width: 40px">
											<v-btn small icon data-tour="expand" :title="checkpresenza(item._id) ? 'Chiudi' : 'Mostra dettaglio'" @click.stop="extension(item._id)">
												<v-icon>{{ checkpresenza(item._id) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
											</v-btn>
										</td>
										<td class="rt-nowrap">
											<div>{{ item.created_at | moment('DD/MM/YYYY') }}</div>
											<div class="rt-sub">{{ item.created_at | moment('HH:mm') }}</div>
										</td>
										<td class="rt-nowrap">
											<v-chip small outlined color="primary" data-tour="order-link" title="Apri ordine" @click.stop="detailItem(item)">
												<v-icon left x-small>mdi-magnify</v-icon>{{ item.OrderID }}
											</v-chip>
											<div v-if="item.Checkout && item.Checkout.PaymentMethods" class="rt-sub mt-1">{{ item.Checkout.PaymentMethods }}</div>
										</td>
										<td>
											<div class="font-weight-medium">{{ nomeCliente(item) || '—' }}</div>
											<div class="rt-sub">{{ item.buyer && item.buyer.email }}</div>
										</td>
										<td>
											<div class="d-flex align-center">
												<div class="rt-mini-thumbs">
													<span v-for="(el, mi) in articoliResi(item).slice(0, 3)" :key="'t' + mi" class="rt-mini-thumb">
														<img v-if="miniatura(el, item)" :src="miniatura(el, item)" alt="" loading="lazy" />
													</span>
												</div>
												<div>
													<div>{{ riepilogoArticoli(item) }}</div>
													<div class="rt-sub">{{ euro(item.Total) }} reso</div>
												</div>
											</div>
										</td>
										<td class="rt-nowrap">
											<v-avatar size="28px" tile>
												<img :src="getImageMarketplace(item.Platform)" :alt="item.Platform" />
											</v-avatar>
											<v-avatar size="16px" tile class="ml-1" v-if="item.Country">
												<img :src="getImageFlag(item)" :alt="item.Country" />
											</v-avatar>
										</td>
										<td data-tour="status">
											<v-chip v-if="item.status && coloreStatoReso(item.status.value)" small :color="coloreStatoReso(item.status.value)" text-color="white">{{ item.status.name }}</v-chip>
											<span v-else-if="item.status">{{ item.status.name }}</span>
										</td>
									</tr>
									<tr v-if="checkpresenza(item._id)" class="rt-expanded">
										<td :colspan="headers.length" class="py-3">
											<ReturnDetail :item="item" @edit="editItem(item)" @open-order="detailItem(item)" />
										</td>
									</tr>
								</template>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';


import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ReturnDetail from '@/components/return/ReturnDetail.vue';
import { immagineRiga } from '@/utils/immagineProdotto';
import { useTour } from '@/components/core/tour/useTour';
import { createReturnsListTourSteps, stopReturnsListTour } from './returns-list-tour';
import { openWithReturn } from '@/components/core/pageReturn';
import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'Return',
	// pagina, righe, ordinamento, ricerca e filtri nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ filters: { status: 'array', platform: 'array', payments: 'array' }, perPageOptions: LIST_SIZE })],
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createReturnsListTourSteps(), { onStop: stopReturnsListTour }),
		};
	},
	data() {
		return {
			menu: false,
			loadingDownload: false,
			errorDownloadReview: '',
			modalDownloadReview: false,

			idStart: '',
			idEnd: '',
			componentKey: 0,
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					status: [],
					platform: [],
					created_at: [],
					preparation_date: [],
					payments: [],
					agents: [],
					color: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),

			listSize: LIST_SIZE,
			linkdownload: '',
			searchfield: '',
			selected: [],
			selectedchecbox: [],
			selectedall: [],
			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: '', value: '', sortable: false },
				{ text: 'Data', value: 'created_at' },
				{ text: 'Ordine', value: 'OrderID' },
				{ text: 'Cliente', value: 'buyer', sortable: false },
				{ text: 'Articoli resi', value: 'Total' },
				{ text: 'Piattaforma', value: 'Platform' },
				{ text: 'Stato', value: 'status' },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			isMobile: true,
			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			parseDate: [],
			dataordine: '',
			datapreparazione: '',
			platform: [],
			packagings: [],
			status: [],
			payments: [],
			agents: [],
			choosePlaform: [],
			chooseStatus: [],
			choosePayments: [],
			Totale: 0,
			Fee: 0,
			Refund: 0,
			Gain: 0,
			page: 1,

			//Invoice Fattureincloud
			TypeInvoice: '',
			InvoiceItem: '',
			magento: false,
			shopify: false,
			prestashop: false,
			woocommerce: false,
			fattureincloud: false,
			dialogOrderSupplier: false,
			idsOrderSupplier: [],
			singleOrderSupplier: false,
			dateOrderSupplier: '',
			checkInPreparazione: true,
			checkRollbackInPreparazione: false,
			operation: '',
			dialogPrint: false,
			dialogPrintMultiple: false,
			users: [],
			user_selected: null,
			courier_selected: null,
			order_to_print: null,
			orders_to_print: null,
			status_elaboration: null,
			selectColor: ['red', 'pink', 'purple', 'indigo', 'blue', 'green', 'yellow', 'orange', 'grey'],
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			//  return  value = value.toFixed(2)
			return _.round(value, 2);
			//return  value
		},
	},

	created() {},
	async mounted() {
		this.setDialog(false);
		this.setExistFilter(true);
		this.linkdownload = `${this.getUrl}nocors/orders/download`;
		this.updateEnableAgents(false);
		let promises = [];
		promises.push(this.fetchSetting());

		//promises.push(this.fetchService(['ebay', 'magento', 'shopify', 'fattureInCloud']));
		promises.push(this.fetchServiceactive(['fattureInCloud', 'ebay', 'magento', 'shopify', 'mws', 'aliexpress', 'prestashop', 'woocommerce']));
		if (this.getRole !== 2) {
			promises.push(this.fetchUsers());
		}

		const result = await Promise.all(promises);
		const status = result[1];

		let magento = status.find(el => el.service === 'magento' && el.active === true);
		if (magento) {
			this.magento = magento.active;
			this.platform.push('Magento');
		}
		let shopify = status.find(el => el.service === 'shopify' && el.active === true);
		if (shopify) {
			this.shopify = shopify.active;
			this.platform.push('Shopify');
		}

		let aliexpress = status.find(el => el.service === 'aliexpress' && el.active === true);
		if (aliexpress) {
			this.aliexpress = aliexpress.active;
			this.platform.push('Aliexpress');
		}

		let prestashop = status.find(el => el.service === 'prestashop' && el.active === true);
		if (prestashop) {
			this.prestashop = prestashop.active;
			this.platform.push('Prestashop');
		}

		let woocommerce = status.find(el => el.service === 'woocommerce' && el.active === true);
		if (woocommerce) {
			this.woocommerce = woocommerce.active;
			this.platform.push('Woocommerce');
		}

		let fattureincloud = status.find(el => el.service === 'fattureInCloud' && el.active === true);
		if (fattureincloud) {
			this.fattureincloud = fattureincloud.active;
		}
		let mws = status.find(el => el.service === 'mws' && el.active === true);
		if (mws) {
			this.platform.push('Amazon');
		}

		let ebay = status.find(el => el.service === 'ebay' && el.active === true);
		if (ebay) {
			this.platform.push('Ebay');
		}

		this.platform.push('Store');

		this.fetchStatusOrder().then(result => {
			var array_colors = this.getSetting?.status_order ? this.getSetting.status_order : [];
			_.forEach(result.data, el => {
				let textStatus = _.find(el.trans, { lang: this.getLanguage });
				let color = _.find(array_colors, { _id: el._id });
				this.status.push({
					text: textStatus.value,
					value: el._id,
					color: color ? color.color : '#FFFFFFF',
				});

				if (el._id === '60deb7436fee57191fa71150') {
					this.status_elaboration = {
						_id: el._id,
						value: textStatus.value,
					};
				}
			});
		});

		this.fetchPaymentMethod().then(result => {
			_.forEach(result.data, el => {
				this.payments.push({ text: el.value, value: el._id });
			});
		});

		this.fetchAgentMethod().then(result => {
			_.forEach(result.data, el => {
				this.agents.push({ text: el.info.name + ' ' + el.info.lastname, value: el._id });
			});
		});

		this.fetchPackagings().then(result => {
			_.forEach(result.data, el => {
				this.packagings.push({ text: el.name, value: el });
			});
			//console.log(this.packagings)
		});

		if (this.getRole !== 2) {
			for (let user of this.getUsers) {
				this.users.push({ name: user.name, _id: user._id });
			}
		}

		// stato della lista (pagina, filtri, ricerca) letto dall'URL in data()
		this.listLoad();
	},
	watch: {
		selectedLength(val) {
			if (val > 0) {
				//_.set(this.selectedall,'[0]',1)
				//_.assign(this.selectedall[0],1)
				this.selectedall = [-1];
			}
		},
		selectedchecbox() {
			if (this.selectedchecbox.length === 1) {
				let el = this.selectedchecbox[0];
				let item = _.find(this.getOrders, i => {
					return i._id === el;
				});
				if (item) {
					if (item.Invoice && item.Invoice.Number) {
						if (item.Invoice.Name === 'Ricevuta') {
							this.TypeInvoice = 'Ricevuta';
						}
						if (item.Invoice.Name === 'Fattura') {
							this.TypeInvoice = 'Fattura';
						}
						this.InvoiceItem = true;
					} else {
						this.InvoiceItem = false;
					}

					if (item.Status === 'In Preparazione') {
						this.checkInPreparazione = false;
						this.checkRollbackInPreparazione = true;
					}
				}
			} else {
				this.checkInPreparazione = true;

				_.forEach(this.selectedchecbox, ord => {
					let item = _.find(this.getOrders, i => {
						return i._id === ord;
					});
					if (item) {
						if (item.Status === 'In Preparazione') {
							this.checkInPreparazione = false;
							this.checkRollbackInPreparazione = true;
						}
					}
				});
			}
		},
	},
	components: {
		ReturnDetail,
		TourOverlay,
		KeyValueCard,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		selectedLength() {
			return this.selectedchecbox.length;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',
			getItems: 'returnstore/getItems',
			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'orders/getIndex',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'orders/getSortBy',
			getSortDesc: 'orders/getSortDesc',
			getLanguage: 'profile/getLanguage',
			getUsers: 'users/getUsers',
			getSetting: 'settings/getSetting',
			getRole: 'profile/getRole',
		}),
		/*Totale(){
                console.log(filteredItems)
                /!*if(filteredItems.length>0) {
                    return filteredItems.reduce((total, current) => {
                        return total + parseFloat(current.Total)
                    })

                }*!/
            },*/
		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		filteredItems() {
			let filters = this.getItems;

			filters = filters.filter(d => {
				//console.log("fine",moment(this.parseDate[1]+" 23:59:59").utc().format());
				if (this.parseDate.length === 1) {
					return (
						d.created_at >
						moment(this.parseDate[0] + ' 00:00:00')
							.utc()
							.format()
					);
				}
				if (this.parseDate.length === 2) {
					return (
						d.created_at >
							moment(this.parseDate[0] + ' 00:00:00')
								.utc()
								.format() &&
						d.created_at <
							moment(this.parseDate[1] + ' 23:59:59')
								.utc()
								.format()
					);
				}
				return d;
			});

			filters = filters.filter(d => {
				if (this.choosePlaform.length > 0) {
					return this.choosePlaform.includes(d.Platform);
				}
				return d;
			});
			filters = filters.filter(d => {
				if (this.chooseStatus.length > 0) {
					return this.chooseStatus.includes(d.Status);
				}
				return d;
			});
			filters = filters.filter(d => {
				if (this.choosePayments.length > 0) {
					return this.choosePayments.includes(d.Checkout.PaymentMethods);
				}
				return d;
			});

			let sum;
			if (filters.length > 0) {
				sum = filters.reduce((total, current) => total + current.Total, 0);

				this.Totale = parseFloat(sum, 2).toFixed(2);
			}
			if (filters.length > 0) {
				sum = filters.reduce((total, current) => total + current.Refund, 0);

				this.Refund = parseFloat(sum, 2).toFixed(2);
			}
			if (filters.length > 0) {
				let total = 0;
				let refund = 0;
				filters.forEach(value => {
					if (value.Buy) {
						total += this.scorporoiva(value.Total, value.BuyVat) - value.Buy - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
					if (value.Refund) {
						refund += value.Total - value.Refund - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
				});
				this.Gain = parseFloat(total + refund, 2).toFixed(2);
			}
			return filters;
		},
		computedDatejs() {
			let arrayDate = [];
			if (this.settings.filters.created_at.length > 0) {
				this.settings.filters.created_at.forEach(value => {
					// console.log(value)
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
		},
		computedDatePrepjs() {
			let arrayDate = [];
			if (this.settings.filters.preparation_date.length > 0) {
				this.settings.filters.preparation_date.forEach(value => {
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
		},
	},

	methods: {
		// coppie chiave/valore della card da telefono (colonne in sola lettura della riga desktop)
		campiCard(item) {
			return [
				{ label: 'Data', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY HH:mm') : '' },
				{ label: 'Articoli', value: this.riepilogoArticoli(item) },
				{ label: 'Totale reso', value: this.euro(item.Total), strong: true },
			];
		},
		nomeCliente(item) {
			const b = item.buyer || {};
			return [b.name, b.lastname].filter(Boolean).join(' ');
		},
		riepilogoArticoli(item) {
			const pezzi = this.articoliResi(item).reduce((n, el) => n + (+el.QuantityReturned || 0), 0);
			return pezzi === 1 ? '1 articolo' : `${pezzi} articoli`;
		},
		miniatura(el, item) {
			return immagineRiga(el, item.itemsImages);
		},
		euro(valore) {
			const n = Number(valore);
			return valore === null || valore === undefined || isNaN(n) ? '—' : `${n.toFixed(2).replace('.', ',')} €`;
		},
		// articoli selezionati per il reso (stesso filtro delle righe desktop)
		articoliResi(item) {
			return (item.Items || []).filter(il => il.selected);
		},
		// colore del chip di stato, come sul desktop (stato sconosciuto = nessun chip)
		coloreStatoReso(value) {
			return {
				CONFIRM_RETURN: 'success',
				REQUEST_RETURN: 'primary',
				ACCEPTED_RETURN: 'warning',
				REQUEST_RETURN_NOT_AUTHORIZED: 'error',
			}[value];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setOrders: 'orders/setOrders',
			setOrder: 'orders/setOrder',
			setItem: 'returnstore/setItem',
			setIndex: 'orders/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
			setSnackbarApp: 'settings/setSnackbar',
			setPackingList: 'packingLists/setPackingList',
		}),
		...mapActions({
			fetchOrders: 'returnstore/asyncFetchData',
			fetchReports: 'orders/asyncFetchReportData',
			destroyData: 'orders/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			createSupplierOrders: 'orders/createSupplierOrders',
			fetchStatusOrder: 'statusorders/fetchLists',
			fetchPaymentMethod: 'paymentmethods/fetchLists',
			fetchAgentMethod: 'agents/fetchLists',
			updateEnableAgents: 'orders/updateEnableAgents',
			getOrdersReview: 'orders/getOrdersReview',
			fetchPackagings: 'packagings/getListings',
			fetchUsers: 'users/asyncFetchUsers',
			fetchServiceactive: 'services/getServiceFetchActive',
			getOrder: 'orders/edit',
		}),
		convertSearch(match) {
			let result = match;

			if (this.settings?.search && result) {
				var re = new RegExp(this.settings.search, 'gi');
				result = match.replace(re, `<mark>${this.settings.search}</mark>`);
			}
			return result;
		},

		convertDataForRange() {
			let stringaData = '';
			const listDate = [];
			const replace = JSON.parse(JSON.stringify(this.settings.filters.created_at));
			if (replace.length > 0) {
				for (let d of replace) {
					const datareplace = new Date(e);
					listDate.push(`${datareplace.getDate()}/${datareplace.getMonth()}/${datareplace.getFullYear()}`);
				}
			}
			if (listDate.length > 0) {
				return listDate.join(' ~ ');
			} else {
				return '';
			}
		},

		async propSetMessages(text) {
			if (text != 'refresh') {
				this.snackbar.color = 'success';
				this.snackbar.text = text;
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
			}
			await this.getDataFromApi();
			this.$forceUpdate();
			this.selectedchecbox = [];
			this.operation = '';
		},
		async creaOrdineFornitore(item) {
			this.dialogOrderSupplier = true;
			if (item) {
				this.singleOrderSupplier = true;
				this.idsOrderSupplier = [item._id];
			} else {
				this.singleOrderSupplier = false;
				this.idsOrderSupplier = [];
			}
		},
		async inviaOrdineFornitore() {
			this.dialogOrderSupplier = false;
			this.preload = true;
			this.setPreload(true);
			let orders_id = this.singleOrderSupplier ? this.idsOrderSupplier : this.selectedchecbox;
			let payload = { order_date: this.dateOrderSupplier, order_ids: orders_id };
			let response = await this.createSupplierOrders(payload);

			this.idsOrderSupplier = [];
			this.singleOrderSupplier = false;

			if (response.result === true && response.all_transformed) {
				await this.fetchOrders(this.settings);
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con  successo';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.preload = false;
				this.setPreload(false);
			} else if (response.result === true && !response.all_transformed) {
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con successo, ma alcuni prodotti non hanno un fornitore associato';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.preload = false;
				this.setPreload(false);
			} else {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore durante invio in preparazione: ' + response.message;
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 10000;
				this.preload = false;
				this.setPreload(false);
			}
		},
		async createItem() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'FormCreate';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		changePackaging(pack, item) {
			let url = 'orders/updatepackaging';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, Packaging: pack.value }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;

					item.Packaging = pack.value;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		changePackagingDelete(item) {
			let url = 'orders/updatepackaging';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, Packaging: {} }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;

					item.Packaging = {};
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		changeStatus(item, color) {
			let url = 'orders/updatestatus';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, color: color }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], { Color: color });
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
		},
		toggle(event) {
			if (_.size(this.selectedall) === 0) {
				this.selectedchecbox = [];
			} else {
				if (event[0] !== -1) {
					this.selectedchecbox = [];
					_.forEach(this.getOrders, cat => {
						this.selectedchecbox.push(cat._id);
					});
				}
			}
		},
		columnValueList(val) {
			return this.getOrders.map(d => d[val]);
		},
		copy(field) {
			let input = document.createElement('input');
			input.setAttribute('value', field);
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			document.body.removeChild(input);
		},
		scorporoiva(totale, iva) {
			let sc = 0;
			if (!iva || iva === 0) {
				iva = 22;
				iva = iva / 100;
				iva += 1;

				sc = parseFloat(totale / iva).toFixed(2);
			} else {
				sc = totale;
			}
			return sc;
		},
		cleardate() {
			this.parseDate = [];
			this.settings.filters.created_at = [];
		},
		cleardatePrep() {
			this.parseDate = [];
			this.settings.filters.preparation_date = [];
		},
		async importItemFromShopify() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'ImportShopify';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async importItemsFromShopify() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'ImportsShopify';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		editItem(item) {
			if (item && item._id) this.$router.push(`/returns/${item._id}`);
		},
		detailItem(item) {
			// l'ordine si apre come pagina; Annulla/Salva tornano qui
			openWithReturn(this, { path: `/orders/${item._order}` }, { label: 'Torna ai resi' });
		},
		// ricerca da tre caratteri; il caricamento lo fa listRouteState
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield : '';
		},
		async duplicateItem(key) {
			this.componentKey += 1;
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}

			this.setClearError({});

			this.operation = 'FormDuplicate';
			this.setIndex(this.getOrders.indexOf(item));
			this.setOrder(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		toggleClass(num) {
			if (num === 1) {
				this.active = !this.active;
			}
			if (this.active) {
				return 'active';
			} else {
				return 'notActive';
			}
		},
		resetForm() {
			this.form._id = '';
			this.form.name = '';
			this.form.email = '';
			this.form.password = '';
			this.form.action = '';
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 3) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
		}, 1000),

		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				//const { sortBy, sortDesc, page, itemsPerPage } = this.settings.options;
				this.settings.filters.enableAgents = false;

				let items = this.fetchOrders(this.settings);
				items.then(result => {
					this.total = result.total;
					//this.items = result.data.data
					this.setPreload(false);
				});
				/*let reports =  this.fetchReports(this.settings).then(result =>{
                        //console.log(result.data.data)
                        if(result.data.data) {
                            this.Totale = result.data.data.total;
                            this.Fee = result.data.data.TotalFee;
                            this.Refund = result.data.data.refund;
                            this.Gain = result.data.data.gain;
                        }


                    });*/
			} catch (err) {
				console.log(err);
			}
		},
		openNew() {
			this.$router.push('/returns/new');
		},

		printOrderMultiple() {
			let url = 'orders/print-multiple';
			this.preload = true;

			axios
				.post(
					`${this.getUrl}${url}`,
					{
						_ids: this.orders_to_print,
						worker: this.user_selected,
						preview_courier: this.courier_selected,
						printed: true,
						status: this.status_elaboration,
					},
					{ headers: { Authorization: `Bearer ${this.getToken}` } },
				)
				.then(() => {
					this.preload = false;
					this.dialogPrintMultiple = false;
					let split = this.orders_to_print.split(',');
					for (let o of this.getOrders) {
						if (split.includes(o._id)) {
							o.worker = this.user_selected;
							o.preview_courier = this.courier_selected;
							o.printed = true;
							o.StatusOrder = this.status_elaboration;
						}
					}

					let route = this.$router.resolve({ path: '/orders/multiple-print/' + this.orders_to_print });
					window.open(route.href, '_blank');
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		openReceipt(item) {
			let route = this.$router.resolve({ path: '/orders/receipt/' + item._id });
			window.open(route.href, '_blank');
		},

		printOrder() {
			let url = 'orders/update-details';
			this.preload = true;

			axios
				.post(
					`${this.getUrl}${url}`,
					{
						_id: this.order_to_print._id,
						worker: this.user_selected,
						preview_courier: this.courier_selected,
						printed: true,
						status: this.status_elaboration,
					},
					{ headers: { Authorization: `Bearer ${this.getToken}` } },
				)
				.then(() => {
					this.preload = false;

					this.dialogPrint = false;
					this.order_to_print.worker = this.user_selected;
					this.order_to_print.preview_courier = this.courier_selected;
					this.order_to_print.printed = true;
					this.order_to_print.StatusOrder = this.status_elaboration;

					let route = this.$router.resolve({ path: '/orders/print/' + this.order_to_print._id });
					window.open(route.href, '_blank');
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		openDialogPrint(item) {
			this.dialogPrint = true;
			this.order_to_print = item;
			this.courier_selected = item.preview_courier ? item.preview_courier : null;
			this.user_selected = item.worker ? item.worker : null;
		},
		printMultiple() {
			let orders_filtered = _.filter(this.getOrders, o => {
				if (this.selectedchecbox.includes(o._id)) {
					return o._id;
				}
			});
			let orders = [];
			for (let order of orders_filtered) {
				orders.push(order._id);
			}
			this.dialogPrintMultiple = true;
			this.orders_to_print = orders.toString();
			this.courier_selected = null;
			this.user_selected = null;
		},

		extension(item) {
			let prova = this.selected.includes(item);
			if (!prova) {
				this.selected.push(item);
			} else {
				let indice = this.selected.indexOf(item);
				this.selected.splice(indice, 1);
			}
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},

		async downloadReviewById() {
			this.errorDownloadReview = '';
			this.loadingDownload = true;
			var result = await this.getOrdersReview({ id_start: this.idStart, id_end: this.idEnd });
			this.loadingDownload = false;

			if (_.size(result.orders) > 0) {
				var textToSave = `RIEPILOGO ORDINI \n\n-------------------------\n`;

				_.forEach(result.orders, order => {
					textToSave += `\nOrdine Id: ${order.OrderID} - Data: ${new Date(order.created_at).toLocaleString()}\n`;
					textToSave += `\n${order.ShippingAddress.Name}\n\n`;

					textToSave += `Prodotti\n`;

					let sku_to_remove = [];

					for (let item of order.Items) {
						if (item.ItemID === 'Virtual') {
							let split_sku = item.SKU.split('-');
							if (split_sku.length > 1) {
								sku_to_remove.push(split_sku[0]);
							}
						}
					}

					if (sku_to_remove.length > 0) {
						order.Items = order.Items.filter(el => {
							return !sku_to_remove.includes(el.SKU);
						});
					}

					for (let item of order.Items) {
						// var name = item.Title.replace(/ *\([^)]*\) */g, "")
						var name = item.Title;
						var split = name.split('-');

						var final;
						if (split.length > 1) {
							var text_1 = split[0].replace(/ *\([^)]*\) */g, '');
							var text_2 = split[1].replace(/ *\([^)]*\) */g, '');
							var replace = text_2.replace(text_1, '');

							final = text_1;
							final += replace == '' || replace == ' ' ? '' : ' -' + replace;
						} else {
							final = name;
						}

						/*
            if(item.kits && item.kits.length > 0){

              textToSave += `-- ${item.Title} - Qtà: ${item.QuantityPurchased}\n`
              _.forEach(item.kits, (kit) =>{
                textToSave += `- ${kit.name} - Qtà: ${kit.qt}\n`
              })

            }else{

             */
						// textToSave += `${item.Title} - Qtà: ${item.QuantityPurchased}\n`
						textToSave += `${final} - Qtà: ${item.QuantityPurchased}\n`;
						//}

						if (_.toString(item.ItemID) == 'Virtual') {
							for (let kit_prod of item.kits) {
								textToSave += `${kit_prod.name}\n`;
							}
						}
					}

					textToSave += `\nMet. Pagamento: ${this.getPayment(order.Checkout.PaymentMethods)} \n`;
					textToSave += `Scatola: ${this.getPackage(order.Packaging)} \n\n`;

					if (order.ShippingService && order.ShippingService.ShippingService.toLowerCase().includes('express')) {
						textToSave += `* Spedizione Express \n\n`;
					}
					if (order.Message) {
						textToSave += `** Sono presenti note nell'ordine \n\n`;
					}
					//textToSave += `Scatola: ${this.getPackageFromColor(order.Color)} \n\n`
					//textToSave += `Corriere: ${(item.package) ? item.package : 'n.d.'} \n\n`

					textToSave += `-------------------------\n`;
				});

				var hiddenElement = document.createElement('a');

				var today = new Date();
				var h = today.getHours();
				var m = today.getMinutes();
				var s = today.getSeconds();

				var now = h + '_' + m + '_' + s;

				hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
				hiddenElement.target = '_blank';
				hiddenElement.download = now + '_riepilogo-ordini.txt';
				hiddenElement.click();
			} else {
				this.errorDownloadReview = 'Gli Id Ordini indicati non risultano corretti per individuare un range';
			}
		},

		async downloadReview() {
			let orders = _.filter(this.getOrders, o => {
				return this.selectedchecbox.includes(o._id);
			});

			if (_.size(orders) > 0) {
				let textToSave = `RIEPILOGO ORDINI \n\n-------------------------\n`;

				_.forEach(orders, order => {
					textToSave += `\nOrdine Id: ${order.OrderID} - Data: ${new Date(order.created_at).toLocaleString()}\n`;
					textToSave += `\n${order.ShippingAddress.Name}\n\n`;

					textToSave += `Prodotti\n`;
					_.forEach(order.Items, item => {
						/*
                    if(item.kits && item.kits.length > 0){

                      textToSave += `-- ${item.Title} - Qtà: ${item.QuantityPurchased}\n`
                      _.forEach(item.kits, (kit) =>{
                        textToSave += `- ${kit.name} - Qtà: ${kit.qt}\n`
                      })

                    }else{

                     */
						textToSave += `${item.Title} - Qtà: ${item.QuantityPurchased}\n`;
						//}
					});
					textToSave += `\nMet. Pagamento: ${this.getPayment(order.Checkout.PaymentMethods)} \n`;
					textToSave += `Scatola: ${this.getPackage(order.Packaging)} \n\n`;
					//textToSave += `Scatola: ${this.getPackageFromColor(order.Color)} \n\n`
					//textToSave += `Corriere: ${(item.package) ? item.package : 'n.d.'} \n\n`

					textToSave += `-------------------------\n`;
				});

				let hiddenElement = document.createElement('a');

				let today = new Date();
				let h = today.getHours();
				let m = today.getMinutes();
				let s = today.getSeconds();

				let now = h + '_' + m + '_' + s;

				hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
				hiddenElement.target = '_blank';
				hiddenElement.download = now + '_riepilogo-ordini.txt';
				hiddenElement.click();
			}
		},
		eliminaFattura(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'fattureincloud/eliminaFattura';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//	console.log(data.data);

					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.snackbar = true;
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;

						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		annullaOrdineFornitore(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'orders-suppliers/rollback';
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, { order_id: item.OrderID.toString() }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					console.log(data.data);

					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					this.getDataFromApi();
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.snackbar = true;
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;

						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		contactWhatsapp(number, order) {
			let message = `Salve la contatto per l'ordine #${order}`;
			let url = `https://api.whatsapp.com/send?phone=${number}&text=${encodeURIComponent(message)}`;
			window.open(url, '_blank');
		},
		getImagePayment(img) {
			if (!img) {
				return require(`@/assets/images/Other.svg`);
			}

			try {
				return require(`@/assets/images/${img.value}.svg`);
			} catch (e) {
				return require(`@/assets/images/Other.svg`);
			}
		},
		getImageShip(item) {
			if (item.ShippedTime) {
				return require(`@/assets/images/box_ship.svg`);
			}
			if (item.CancelTime) {
				return require(`@/assets/images/box_cancel.svg`);
			}
			let delivery;
			item.Items.forEach(value => {
				delivery = value.Delivery_max;
			});

			if (delivery) {
				let fromDate = parseInt(new Date().getTime() / 1000);
				let toDate = parseInt(new Date(delivery).getTime() / 1000);
				let timeDiff = (toDate - fromDate) / 3600; // will give difference in hrs
				let box = '';

				if (timeDiff > 6) {
					return require(`@/assets/images/box.svg`);
				}
				if (timeDiff > 1 && timeDiff <= 6) {
					return require(`@/assets/images/box_warning.svg`);
				}
				if (timeDiff <= 1) {
					return require(`@/assets/images/box_late.svg`);
				}
				return require(box);
			} else {
				return require(`@/assets/images/box.svg`);
			}
		},

		getImageMarketplace(img) {
			let logo = '';
			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				case 'Cassa':
					logo = require(`@/assets/images/cassa.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img.Country}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		closeSnackbar() {
			this.setSnackbar(false);
		},
		// async confirm() {
		// 	let payload = this.form;
		// 	try {
		// 		this.preload = true;
		// 		await this.fetchUsers(payload);
		// 	} catch (err) {
		// 		console.log(err);
		// 	}
		// 	this.preload = false;
		// },

		getPackage(Packaging) {
			if (Packaging !== undefined) {
				return Packaging.name;
			} else {
				return 'n.d.';
			}
		},
		getPackageFromColor(color) {
			switch (color) {
				case 'grey':
					return 'n.d.';
				case 'red':
					return 1;
				case 'pink':
					return 2;
				case 'purple':
					return 3;
				case 'indigo':
					return 4;
				case 'blue':
					return 5;
				case 'green':
					return 6;
				case undefined:
					return 'n.d.';
				default:
					return 'n.d.';
			}
		},
		getPayment(payment) {
			switch (payment) {
				case 'american express':
				case 'creditcard':
				case 'maestro':
				case 'mastercard':
				case 'paypal':
				case 'visa':
					return 'Pagato';
				case 'bonifico bancario':
					return 'Bonifico';
				case 'cash on delivery (cod)':
				case 'cash on delivery cod':
				case 'cod':
					return 'Contrassegno';
				default:
					return payment;
			}
		},
		getStatusColor(statusId, prep_date) {
			// Fix Madò, in caso di ordine con data preparazione considera come in elaborazione
			if (prep_date !== null && (this.getId === '636f52667160ac8bc2d6df78' || this.getId === '60b2554c7aee6b735869408c')) {
				statusId._id = '60deb7436fee57191fa71150';
			}
			if (statusId && statusId._id) {
				let status = _.find(this.status, { value: statusId._id });
				return status ? status.color : '#FFFFFF';
			} else {
				return '#FFFFFF';
			}
		},
		formatPhoneNumber(phoneNumberString) {
			let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
			let match = cleaned.match(/^(39|)?(\d{3})(\d{3})(\d{4})$/);
			if (match) {
				let intlCode = match[1] ? '+39' : '+39';
				return [intlCode, match[2], match[3], match[4]].join('');
			} else {
				return null;
			}
		},
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		this.destroyData();
	},
};
</script>

<style scoped>
.v-tooltip__content {
	position: absolute !important;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100%.
   Qui la tabella usa lo slot `item`: il tbody lo genera v-data-table, quindi serve ::v-deep */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.return-cards ::v-deep tbody,
.return-cards ::v-deep tbody tr {
	display: block;
	width: 100%;
}
.return-cards ::v-deep tbody tr,
.return-cards ::v-deep tbody tr:hover {
	background: transparent !important;
}
.return-cards ::v-deep tbody td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.return-cards ::v-deep tbody tr:first-child td {
	padding-top: 12px !important;
}
.return-cards ::v-deep tbody tr:last-child td {
	padding-bottom: 12px !important;
}
.return-cards ::v-deep tbody tr + tr td {
	padding-top: 8px !important;
}
/* lista compatta */
.rt-list-row {
	cursor: pointer;
}
.rt-list-row--open,
.rt-list-row--open:hover {
	background: #f3f6fa !important;
}
.rt-expanded,
.rt-expanded:hover {
	background: transparent !important;
}
.rt-nowrap {
	white-space: nowrap;
}
.rt-sub {
	font-size: 12px;
	color: rgba(0, 0, 0, 0.6);
}
/* miniature sovrapposte degli articoli resi */
.rt-mini-thumbs {
	display: flex;
	margin-right: 10px;
}
.rt-mini-thumb {
	width: 32px;
	height: 32px;
	border-radius: 6px;
	border: 1px solid #e1e7ef;
	background: #f7f9fc;
	overflow: hidden;
	flex: 0 0 32px;
}
.rt-mini-thumb + .rt-mini-thumb {
	margin-left: -10px;
}
.rt-mini-thumb img {
	width: 100%;
	height: 100%;
	object-fit: contain;
	background: #fff;
}
</style>
